/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";
import { enqueueSnackbar } from "notistack";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import useYupValidationResolver from "src/hooks/useYupValidationResolver";

import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  createFilterOptions,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import AddIcon from "@mui/icons-material/Add";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import {
  createOrderDraft,
  findOneOrderDraft,
  updateOrderDraft,
} from "src/api/saleOrder";
import { searchProduct } from "src/api/product";
import { getQuotationList } from "src/api/quotation";
import { getAllCustomer } from "src/api/quotationDraft";
import { getDelivery } from "src/api/order";
import { getAdminList } from "src/api/admin";

import device from "src/styles/device";
import font from "src/styles/font";
import { Black, Primary } from "src/styles/color";
import { renameFile } from "src/common/file";
import {
  checkNotEmpty,
  convertIntToCurrency,
  formatFromElastic,
} from "src/common";

import { useDialog } from "src/context/DialogContext";
import useModal from "src/hooks/useModal";
import useDeviceSize from "src/hooks/useDeviceSize";

import Main from "src/components/ui/Container";
import Button from "src/components/core/Button";
import AddressAutocomplete from "src/components/core/AddressAutocomplete";
import UploadPdf from "src/components/upload/dropzone/UploadPdf";

import ModalAddition from "src/modules/quotation-draft/CreateQuoDraft/AdditionModal";
import ModalProduct from "src/modules/sale-features/ProductSheet";
import ProductSheet from "src/modules/sale-features/ProductSheet";

const Container = styled.div`
  width: 100%;
  padding: 40px 34px;
  /* margin-top: 75px; */

  @media ${device.tabletL} {
    padding: 20px 0;
  }
`;

const Header = styled.span`
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  display: inline-block;
  width: 100%;
  text-align: center;

  @media ${device.tabletL} {
    font-size: 1rem;
  }
`;

const Panel = styled.div`
  border-radius: 24px;
  border: 1px solid var(--Grey-stroke, #d8d8dc);
  background: var(--White, #fff);
  display: flex;
  margin: 24px auto 0 auto;
  padding: 30px 24px 40px 24px;
  width: 100%;
  max-width: 1152px;

  @media ${device.tabletL} {
    padding: 0px 40px;
    border: none;
  }
  @media ${device.mobileL} {
    padding: 0 24px;
  }
`;

const Product = styled.div`
  display: flex;
  padding: 24px 24px 40px 24px;
  width: 100%;
  max-width: 1152px;
  margin: 0 auto;
  flex-direction: column;

  @media ${device.tabletL} {
    padding: 8px 24px 40px 24px;
    margin-bottom: 100px;
  }
  @media ${device.mobileL} {
    margin-bottom: 100px;
  }
`;

const Topic = styled.span`
  color: ${({ condition, required }) =>
    condition ? "#6C6C70" : required ? "#E13B30" : "#252525"};
  font-family: Prompt;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  display: block;
  display: flex;
  margin-left: ${({ condition }) => condition && "10px"};

  @media ${device.tabletL} {
    font-size: 1rem;
  }
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: ${({ margin }) => margin};
`;

const PanelProduct = styled.div`
  width: 100%;
  margin: 12px 0;
  border-radius: 16px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
`;

const HeaderPanel = styled.div`
  width: 100%;
  padding: 10px 16px;
  border-radius: 16px 16px 0 0;
  background-color: #f3f1f2;
`;

const BodyPanel = styled.div`
  padding: 16px 24px;

  @media ${device.mobileL} {
    padding: 12px 16px;
  }
`;

const FooterPanel = styled.div`
  padding: 16px 24px;
  background-color: #f3f1f2;
  border-radius: 0 0 16px 16px;
`;

const ShopName = styled.span`
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  color: #000000;
`;

const Price = styled.div`
  width: 100%;
  color: ${({ sum, discount, price }) =>
    sum ? "#E13B30" : discount ? "#219653" : price ? "#252525" : "#6C6C70"};
  font-family: Prompt;
  font-size: 1rem;
  font-style: normal;
  font-weight: ${({ sum }) => (sum ? 600 : 400)};
  text-align: ${({ price }) => price && "right"};
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ProductChoiceDetail = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 35% 35% 30%;
  align-items: center;
  padding: 5px 0;
`;

const SpanProductDetail = styled.span`
  color: ${({ nameProd }) => (nameProd ? "#252525" : "#6C6C70")};
  font-size: 1rem;
  font-weight: 400;
  text-align: ${({ center }) => (center ? "center" : "left")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ price }) =>
    price &&
    css`
      color: #e13b30;
      font-size: 1.25rem;
      font-weight: 600;

      align-self: flex-end;
      text-align: right;
      grid-column: 3;
      grid-row: 1 / span 2;
    `}
`;

const ButtonSubmit = styled.button`
  display: flex;
  width: 350px;
  padding: 12px 148px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: #e13b30;
  cursor: pointer;
  color: #fff;
  font-size: 1rem;
  border: none;
  font-weight: 500;

  :disabled {
    background-color: lightgray;
    cursor: no-drop;
  }
`;

const TextHeight = styled.span`
  color: #252525;
  font-size: 1rem;
  font-style: normal;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
`;

const ProductDetail = styled.span`
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  color: #6c6c70;
`;

const ButtonQuantity = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const InputQuantity = styled.input`
  width: 87px;
  height: 32px;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  border-radius: 8px;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
  color: #252525;
  font-family: Prompt;
  margin: 0 10px;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const ButtonSumPriceProduct = styled.div`
  width: 150px;
  height: 40px;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  font-family: Prompt;
  color: #252525;

  @media ${device.mobileL} {
    width: 120px;
  }
`;

const TextMedium = styled.span`
  font-size: 0.875rem;
  color: #252525;
  font-weight: 400;
`;

const LineSection = styled.div`
  width: 100%;
  height: ${({ large }) => (large ? "10px" : "1px")};
  background-color: #d9d9d9;
  margin: 16px 0;
  display: ${({ large }) => (large ? "none" : "block")};

  @media ${device.tabletL} {
    display: ${({ large }) => (large ? "block" : "block")};
  }
`;

const AddRemark = styled.div`
  color: #e13b30;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-left: 18px;
  cursor: pointer;
`;

const TotalPrice = styled.span`
  font-family: Prompt;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: ${({ price }) => (price ? 600 : 400)};
  color: ${({ price }) => (price ? "#E13B30" : "#000000")};
`;

const ButtomSheet = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-radius: 16px 16px 0 0;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 15;
  box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
`;

const phoneRegExp = /\d{10}/;

const validationSchema = yup.object().shape({
  customer_name: yup.string(),
  customer_tel: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Please enter phone number"),
  customer_email: yup
    .string()
    .email("E-mail is incorrect")
    .test({
      name: "format incorrect",
      message: "E-mail is incorrect",
      test: (value, context) => {
        const regex = /@[^.]*\./;
        if (value !== "" && !regex.test(value)) {
          return false;
        }
        return true;
      },
    }),
  shipping_address: yup.object().shape({
    name: yup.string(),
    tel: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Please enter phone number"),
    address: yup.string().required("Please enter shipping address"),
    province: yup.string().required("Please enter province"),
    district: yup.string().required("Please enter district"),
    subdistrict: yup.string().required("Please enter subdistrict"),
    zipcode: yup.string().required("Please enter zipcode"),
  }),
  expire_date: yup.string().required("Please enter expire date"),
  seller_list_orders: yup
    .array()
    .of(yup.object())
    .required("Please select at least one product"),
  quotation_pdf: yup.mixed().nullable(),
});

const OrderDraft = ({ open }) => {
  const navigate = useNavigate();
  const { orderId } = useParams();

  const [deviceWidth] = useDeviceSize();
  const { openDialog, closeDialog } = useDialog();
  const { getModalState, open: openModal, close } = useModal();

  const [customerList, setCustomerList] = useState([]);
  // const [sellerData, setSellerData] = useState({});
  const [quotationsList, setQuotationsList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [adminList, setAdminList] = useState([]);

  const defaultValues = {
    customer_name: "",
    customer_tel: "",
    customer_email: "",
    shipping_address: {
      name: "",
      tel: "",
      address: "",
      province: "",
      district: "",
      subdistrict: "",
      zipcode: "",
    },
    expire_date: "",
    seller_list_orders: [],
    quotation_pdf: null,
  };
  const [orderForm, setOrderForm] = useState(defaultValues);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedSale, setSelectedSale] = useState(null);
  const [selectedDelivery, setSelectedDelivery] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);

  const [sellerIndex, setSellerIndex] = useState(0);
  const [choiceIndex, setChoiceIndex] = useState(0);

  const fetchOrder = async () => {
    const { data } = await findOneOrderDraft(orderId);
    setOrderForm({ ...data });
    const _selectedProduct = data.seller_list_orders.flatMap((order) =>
      order.product_choice_orders.map((prod) => prod.product_choice_order),
    );
    setSelectedProduct(_selectedProduct);
  };

  useEffect(() => {
    if (orderId) {
      fetchOrder();
    }
  }, [orderId]);

  let resolver = useYupValidationResolver(validationSchema);

  const {
    handleSubmit,
  } = useForm({
    resolver,
    defaultValues,
  });

  const fetchCustomer = async () => {
    const { data } = await getAllCustomer();
    setCustomerList(data);
  };

  const fetchAdmin = async () => {
    const { rows: data } = await getAdminList({
      keyword: null,
      page: 0,
      page_size: 100,
      status: "all",
    });
    setAdminList(data);
  };

  const fetchQuotations = async () => {
    const dataSearch = {
      page: 0,
      page_size: 10,
      status: "",
      order_case: "desc",
    };
    const {
      data: { rows },
    } = await getQuotationList({ ...dataSearch });
    setQuotationsList(rows);
  };

  const fetchProducts = async () => {
    const { data } = await searchProduct({});
    setProductList(
      data?.rows.length > 0
        ? data?.rows?.map((product) => ({
            ...formatFromElastic(product),
          }))
        : [],
    );
  };

  const fetchDeliveryTypes = async () => {
    const { data } = await getDelivery();
    setSelectedDelivery(data);
  };

  const fetchCopyOrder = async () => {
    let order = await window.localStorage.getItem("order");
    if (!!order && !orderId) {
      let data = JSON.parse(order);

      const { createdAt, expire_date, ...restData } = data;

      // if old expire_date is invalid, set expire_date to current date + 1 day
      let exp_date = dayjs(expire_date).isBefore(dayjs(new Date())) ? dayjs(new Date()).add(1, 'day') : dayjs(expire_date);

      await setOrderForm({
        ...restData,
        expire_date: exp_date.format("YYYY-MM-DD"),
      });
      const _selectedProduct = data.seller_list_orders.flatMap((order) =>
        order.product_choice_orders.map((prod) => prod.product_choice_order),
      );
      setSelectedProduct(_selectedProduct);
      setSelectedSale(data.created_by?.user_id);
      // await window.localStorage.removeItem("order");
    }
  };

  useEffect(() => {
    // fetchProvinceData();
    fetchCustomer();
    fetchQuotations();
    fetchProducts();
    fetchDeliveryTypes();
    fetchCopyOrder();
    fetchAdmin();
  }, []);

  useEffect(() => {
    if (selectedProduct.length === 0) {
      setOrderForm({ ...orderForm, seller_list_orders: [] });
    }
  }, [selectedProduct]);

  // Sync selectedSeller with order form

  const handleSelectProduct = async (product, event) => {
    if (event === "removeOption") {
      let formNew = orderForm;

      if (product.length > 0) {
        let seller_list = orderForm.seller_list_orders
          .map((order) => {
            let productNew = order.product_choice_orders.filter((prod) => {
              return product.find((prodChoose) => {
                if (prod._id === prodChoose._id) return prodChoose;
              });
            });
            order.product_choice_orders = productNew;
            return order;
          })
          .filter((order) => order.product_choice_orders.length > 0);
        formNew = {
          ...orderForm,
          seller_list_orders: seller_list,
        };
        setOrderForm(formNew);
      }
    } else {
      const groupBy = (array, property) => {
        return array.reduce((acc, obj) => {
          const seller_id = obj.product.user?.seller?.[property];
          let product = {
            ...obj,
            // product_choice_order: obj._id,
            product_choice_order: obj,
            volume: 1,
            total: obj.group_price.price * 1,
            price: obj.group_price.price,
            description: "",
            discount: 0,
            install_detail_group: {
              is_service: false,
              install_area: "",
              service_price: "",
              service_note: "",
              total_install: "",
            },
          };

          if (!acc["product_choice_orders"]) {
            acc["product_choice_orders"] = [];
          }

          // && acc['seller'] !== seller_id
          if (!!acc["seller"]) {
            let product = {
              ...obj,
              // product_choice_order: obj._id,
              product_choice_order: obj,
              volume: 1,
              total: obj.group_price.price * 1,
              price: obj.group_price.price,
              description: "",
              discount: 0,
              install_detail_group: {
                is_service: false,
                install_area: "",
                service_price: "",
                service_note: "",
                total_install: "",
              },
            };
            let seller = {
              seller_name: obj.product.user.seller.company_name,
              seller: seller_id,
              delivery_detail_group: {
                is_delivery: false,
                delivery_price: 0,
                delivery_type: null,
              },
              status_payment: {
                status: "paid",
                deposit_price: 0,
              },
              vat: 0,
              packaging_fee: 0,
              total_price: 0,
              total_vat: 0,
              total_installer: 0,
              total_delivery: 0,
              total_packaging: 0,
              total_discount: 0,
              note: "",
              product_choice_orders: [product],
            };
            return seller;
          } else {
            acc["seller_name"] = obj.product.user.seller.company_name;
            acc["seller"] = seller_id;
            acc["delivery_detail_group"] = {
              is_delivery: false,
              delivery_price: 0,
              delivery_type: null,
            };
            acc["status_payment"] = {
              status: "paid",
              deposit_price: 0,
            };
            acc["vat"] = 0;
            acc["packaging_fee"] = 0;
            acc["total_price"] = 0;
            acc["total_vat"] = 0;
            acc["total_installer"] = 0;
            acc["total_delivery"] = 0;
            acc["total_packaging"] = 0;
            acc["total_discount"] = 0;
            acc["note"] = "";
            acc["product_choice_orders"].push(product);
          }
          return acc;
        }, {});
      };

      const groupedData = groupBy(product, "_id");
      const formDup = orderForm;
      formDup.total_seller_price = 0;
      formDup.status = "available";

      if (
        !!orderForm.seller_list_orders &&
        orderForm.seller_list_orders.length > 0
      ) {
        if (
          orderForm.seller_list_orders.find(
            (order) =>
              order.product_choice_orders[0].product_choice_order.product.user
                .seller._id === groupedData.seller,
          ) === undefined
        ) {
          formDup.seller_list_orders = [
            ...orderForm.seller_list_orders,
            groupedData,
          ];
        } else {
          formDup.seller_list_orders = formDup.seller_list_orders.map(
            (order) => {
              if (
                order.product_choice_orders[0].product_choice_order.product.user
                  .seller._id === groupedData.seller
              )
                order.product_choice_orders.push(
                  groupedData.product_choice_orders[0],
                );
              return order;
            },
          );
        }
      } else {
        formDup.seller_list_orders = [groupedData];
      }
      setOrderForm({ ...formDup });
    }
  };

  const handleOldCustomer = (customer) => {
    if (customer) {
      setSelectedCustomer(customer);
      setOrderForm((form) => ({
        ...form,
        customer_name: customer.contact.full_name,
        customer_tel: customer.contact.phone_number,
        customer_email: customer.contact.email,
        shipping_address: {
          name: customer.contact.full_name,
          tel: customer.contact.phone_number,
          address: customer.contact.address,
          province: customer.contact.province,
          district: customer.contact.district,
          subdistrict: customer.contact.sub_district,
          zipcode: customer.contact.zipcode,
        },
      }));
    } else {
      setSelectedCustomer(null);
    }
  };

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

  const deleteCopyOrder = async () => {
    let order = localStorage.getItem("order");

    if (!!order) {
      localStorage.removeItem("order");
    }
  };

  const convertPrice = (price) =>
    Intl.NumberFormat("th-TH", {
      style: "currency",
      currency: "THB",
    }).format(price);

  const handleCreateOrder = async () => {
    const formNew = {
      ...orderForm,
      created_by: {
        user_id:
          orderForm.created_by?.user_id?._id || orderForm.created_by?.user_id,
      },
      ...(orderForm.quotation_pdf
        ? { quotation_pdf: renameFile(orderForm.quotation_pdf, "QTCS") }
        : {}),
    };
    if (!!orderForm.ref_quotation) {
      formNew.ref_quotation = orderForm.ref_quotation._id;
    }

    // formNew.seller_list_orders.forEach((order) => {
    //   delete order.seller;
    // });

    createOrderDraft(formNew)
      .then(({ data }) => {
        if (!!data) {
          enqueueSnackbar("สร้างออเดอร์สำเร็จ", {
            variant: "success",
          });

          setTimeout(() => {
            navigate(`/sale-order/detail/${data?.order_draft_id}`);
          }, [2000]);
        }
      })
      .catch((err) => {
        enqueueSnackbar("สร้างออเดอร์ไม่สำเร็จ", {
          variant: "error",
        });
      })
      .finally(() => deleteCopyOrder());
  };

  const handleUpdateOrder = async () => {
    const formNew = orderForm;
    formNew.seller_list_orders.forEach((order) => {
      if (typeof order.seller !== "string") {
        order.seller = order.seller?._id;
      }
    });

    updateOrderDraft(formNew)
      .then(({ data }) => {
        enqueueSnackbar("แก้ไขออเดอร์สำเร็จ", {
          variant: "success",
        });
        setTimeout(() => {
          navigate(`/sale-order/list`);
          // navigate(`/sale-order/detail/${data?.order_draft_id}`);
        }, [2000]);
      })
      .catch((err) => {
        enqueueSnackbar("แก้ไขออเดอร์ไม่สำเร็จ", {
          variant: "error",
        });
      });
  };

  const onSubmit = () => {};

  const minusVolume = (iSeller, iChoice) => {
    const formNew = orderForm;
    let prevVolume =
      formNew.seller_list_orders[iSeller].product_choice_orders[iChoice].volume;
    prevVolume === 1
      ? (formNew.seller_list_orders[iSeller].product_choice_orders[
          iChoice
        ].volume = 1)
      : (formNew.seller_list_orders[iSeller].product_choice_orders[
          iChoice
        ].volume -= 1);
    setOrderForm((form) => ({ ...form, ...formNew }));
  };

  const addVolume = (iSeller, iChoice) => {
    const formNew = orderForm;
    formNew.seller_list_orders[iSeller].product_choice_orders[iChoice].volume +=
      1;
    setOrderForm((form) => ({ ...form, ...formNew }));
  };

  const handleVolume = (value, iSeller, iChoice) => {
    const formNew = orderForm;
    formNew.seller_list_orders[iSeller].product_choice_orders[iChoice].volume =
      Number(value);
    setOrderForm((form) => ({ ...form, ...formNew }));
  };

  const handleSumPrice = () => {
    if (
      !!orderForm?.seller_list_orders &&
      orderForm?.seller_list_orders?.length > 0
    ) {
      let formNew = orderForm.seller_list_orders
        .map((order) => {
          if (order.product_choice_orders.length > 0) {
            order.product_choice_orders = order.product_choice_orders.map(
              (product) => {
                product.discount = !!product.discount_percent
                  ? ((product?.group_price?.special_price ?? product?.price) *
                      product?.volume *
                      product.discount_percent) /
                    100
                  : (Number(product?.discount) ?? 0);
                product.total =
                  (product?.group_price?.special_price ?? product?.price) *
                    product?.volume +
                  Number(product?.install_detail_group?.service_price) +
                  Number(product?.install_detail_group?.total_install) -
                  (!!product.discount_percent
                    ? ((product?.group_price?.special_price ?? product?.price) *
                        product?.volume *
                        product.discount_percent) /
                      100
                    : Number(product?.discount));
                return product;
              },
            );

            order.total_discount = order.product_choice_orders
              .filter((prod) => prod.discount)
              .map((prod) => prod.discount)
              .reduce((sum, number) => {
                return Number(sum) + Number(number);
              }, 0);
            order.total_price = order?.product_choice_orders
              ?.map((prod) => prod.total)
              .reduce((sum, number) => {
                return sum + number;
              }, 0);
            order.total_installer = order?.product_choice_orders
              ?.filter((prod) => prod.install_detail_group.is_service === true)
              .map(
                (prod) =>
                  Number(prod.install_detail_group.total_install) +
                  Number(prod.install_detail_group.service_price),
              )
              .reduce((sum, number) => {
                return Number(sum) + Number(number);
              }, 0);
            order.vat = (order?.total_price * 7) / 100;
            order.total_vat = order.total_price + order.vat;
            order.total_delivery = Number(
              order.delivery_detail_group.delivery_price
                ? +order.delivery_detail_group.delivery_price +
                    +(order.delivery_detail_group.delivery_price * 7) / 100
                : 0,
            );
            order.total_packaging = Number(
              order.packaging_fee
                ? +order.packaging_fee + +(order.packaging_fee * 7) / 100
                : 0,
            );
            order.total_all =
              order.status_payment.status === "deposit"
                ? order.status_payment.deposit_price
                : order.total_vat +
                  order.total_delivery +
                  order.total_packaging;
            order.outstanding_balance =
              order.status_payment.status === "deposit"
                ? order.total_vat +
                  order.total_delivery +
                  order.total_packaging -
                  order.status_payment.deposit_price
                : // order.total_price - order.status_payment.deposit_price
                  0;
            order.credit_card_fee =
              order?.credit_card_fee !== null &&
              order?.credit_card_fee !== undefined &&
              order?.credit_card_fee !== false &&
              !isNaN(order?.credit_card_fee) &&
              order?.credit_card_fee !== ""
                ? parseFloat(order.credit_card_fee)
                : null;
            //ยอดรวมค้างชำระ = (ราคาสินค้า*จำนวน) ทั้งหมด + ค่าติดตั้งทั้งหมด - ส่วนลดทั้งหมด + vat 7% + ค่าจัดส่งทั้งหมด   จากนั้นลบออกด้วย total_all
            return order;
          } else {
            order.total_discount = 0;
            order.total_price = 0;
            order.total_installer = 0;
            order.vat = 0;
            order.total_vat = order.total_price + order.vat;
            order.total_delivery = 0;
            order.total_packaging = 0;
            order.total_all =
              order.status_payment.status === "deposit"
                ? order.status_payment.deposit_price
                : order.total_vat +
                  order.total_delivery +
                  order.total_packaging;
            order.outstanding_balance =
              order.status_payment.status === "deposit"
                ? order.total_vat +
                  order.total_delivery +
                  order.total_packaging -
                  order.status_payment.deposit_price
                : // order.total_price - order.status_payment.deposit_price
                  0;
            //ยอดรวมค้างชำระ = (ราคาสินค้า*จำนวน) ทั้งหมด + ค่าติดตั้งทั้งหมด - ส่วนลดทั้งหมด + vat 7% + ค่าจัดส่งทั้งหมด   จากนั้นลบออกด้วย total_all

            return order;
          }
        })
        .filter((order) => order.product_choice_orders.length > 0);
      setOrderForm((form) => ({
        ...form,
        seller_list_orders: formNew,
        total_seller_price: orderForm.seller_list_orders
          .map((order) => order.total_all)
          .reduce((sum, number) => {
            return Number(sum) + Number(number);
          }, 0),
      }));
    }
  };

  const removeProductSelect = (iSeller, iChoice, prodId) => {
    let formNew = orderForm;
    formNew.seller_list_orders[iSeller].product_choice_orders.splice(
      iChoice,
      1,
    );
    if (
      formNew.seller_list_orders[iSeller].product_choice_orders.length === 0
    ) {
      formNew.seller_list_orders.splice(iSeller, 1);
    }
    setOrderForm({ ...formNew });

    let productRemain = selectedProduct.filter((prod) => prod._id !== prodId);
    setSelectedProduct([...productRemain]);
    handleSumPrice();
  };

  const isDisableSubmit = () => {
    if (orderForm?.expire_date && orderForm?.seller_list_orders.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <Main bg="white" open={open}>
      <Container>
        {!!orderId ? (
          <Header>แก้ไขออเดอร์</Header>
        ) : (
          <Header>สร้างออเดอร์ให้ลูกค้า</Header>
        )}

        <Panel>
          <Grid container ml={0} columnSpacing={4}>
            <FormControl fullWidth onSubmit={handleSubmit(onSubmit)}>
              <Grid xs={12} mb={4}>
                <Row margin="0 0 16px 0">
                  <Topic>
                    เพิ่มข้อมูลจากลูกค้าเก่า<Topic condition>(หากมี)</Topic>
                  </Topic>
                </Row>

                <Grid
                  xs={12}
                  sm={10}
                  md={5.8}
                  mx={{ sm: "auto", md: 0 }}
                  container
                >
                  <Autocomplete
                    id="search-customer-similars"
                    isOptionEqualToValue={(option, value) =>
                      option.filter === value.filter
                    }
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          padding: "8px 24px",
                          ":first-child": {
                            paddingTop: "24px",
                          },
                          ":last-child": {
                            paddingBottom: "24px",
                          },
                        }}
                      >
                        {`${
                          checkNotEmpty(option?.contact?.full_name) ||
                          option?.contact?.full_name !== ""
                            ? option?.contact?.full_name
                            : option?.contact?.company_name !== ""
                              ? option?.contact?.company_name
                              : option?.email
                        } ${
                          option?.project !== "" ? `(${option?.project})` : ``
                        }`}
                      </li>
                    )}
                    options={customerList}
                    value={selectedCustomer}
                    onChange={(event, newValue) => {
                      handleOldCustomer(newValue);
                    }}
                    getOptionLabel={(option) => {
                      return `${
                        checkNotEmpty(option?.contact?.full_name) ||
                        option?.contact?.full_name !== ""
                          ? option?.contact?.full_name
                          : option?.contact?.company_name !== ""
                            ? option?.contact?.company_name
                            : option?.email
                      } ${
                        option?.project !== "" ? `(${option?.project})` : ``
                      }`;
                    }}
                    filterOptions={filterOptions}
                    sx={{
                      width: "100%",
                      background: "#fff",
                      ".MuiOutlinedInput-root": {
                        paddingLeft: "16px",
                      },
                      ".MuiAutocomplete-option": {
                        p: 3,
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        className="TextField-without-border-radius"
                        {...params}
                        label="ค้นหาจากชื่อ/ชื่อโครงการ"
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Grid xs={12} mb={4}>
                <Row margin="0 0 16px 0">
                  <Topic>
                    ข้อมูล
                    {/* <Topic required>*</Topic> */}
                  </Topic>
                </Row>

                <Grid
                  container
                  justifyContent={{ sm: "center", md: "space-between" }}
                >
                  <Grid xs={12} sm={10} md={5.8}>
                    <TextField
                      required
                      fullWidth
                      size="medium"
                      label="ชื่อ นามสกุล"
                      value={orderForm?.customer_name ?? ""}
                      onChange={({ target }) =>
                        setOrderForm((form) => ({
                          ...form,
                          customer_name: target.value,
                        }))
                      }
                      // error={!!errors.name}
                      // helperText={
                      //   !!errors.name
                      //     ? "Please enter full name"
                      //     : ""
                      // }
                      // {...register('name')}
                    />
                  </Grid>

                  <Grid xs={12} sm={10} md={5.8} my={{ xs: 2, sm: 2, md: 0 }}>
                    <TextField
                      required
                      fullWidth
                      size="medium"
                      label="อีเมล"
                      value={orderForm?.customer_email ?? ""}
                      onChange={({ target }) =>
                        setOrderForm((form) => ({
                          ...form,
                          customer_email: target.value,
                        }))
                      }
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  mt={{ md: 3 }}
                  justifyContent={{ sm: "center", md: "space-between" }}
                >
                  <Grid xs={12} sm={10} md={5.8}>
                    <TextField
                      required
                      fullWidth
                      size="medium"
                      label="เบอร์โทรศัพท์"
                      placeholder="เฉพาะตัวเลข 10 หลัก"
                      value={orderForm?.customer_tel ?? ""}
                      onChange={({ target }) =>
                        setOrderForm((form) => ({
                          ...form,
                          customer_tel: target.value,
                        }))
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} mb={4}>
                <Row margin="0 0 16px 0">
                  <Topic>
                    ที่อยู่
                    {/* <Topic required>*</Topic> */}
                  </Topic>
                </Row>

                <Grid
                  container
                  justifyContent={{ sm: "center", md: "space-between" }}
                >
                  <Grid xs={12} sm={10} md={5.8} my={{ xs: 1, sm: 1, md: 0 }}>
                    <AddressAutocomplete
                      value={
                        checkNotEmpty(orderForm?.shipping_address?.province)
                          ? {
                              province:
                                orderForm?.shipping_address?.province || "",
                              district:
                                orderForm?.shipping_address?.district || "",
                              subdistrict:
                                orderForm?.shipping_address?.subdistrict || "",
                              zipcode:
                                orderForm?.shipping_address?.zipcode || "",
                            }
                          : null
                      }
                      onChange={(value) => {
                        if (value) {
                          setOrderForm((form) => ({
                            ...form,
                            shipping_address: {
                              ...form.shipping_address,
                              province: value.province,
                              district: value.district,
                              subdistrict: value.subdistrict,
                              zipcode: value.zipcode,
                            },
                          }));
                        } else {
                          setOrderForm((form) => ({
                            ...form,
                            shipping_address: {
                              ...form.shipping_address,
                              province: "",
                              district: "",
                              subdistrict: "",
                              zipcode: "",
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="TextField-without-border-radius"
                          {...params}
                          label="ตำบล/อำเภอ/จังหวัด/รหัสไปรษณีย์"
                          variant="outlined"
                          fullWidth
                          required
                          // error={
                          //   orderForm?.shipping_address?.province === "" ||
                          //   orderForm?.shipping_address?.district === "" ||
                          //   orderForm?.shipping_address?.subdistrict === "" ||
                          //   orderForm?.shipping_address?.zipcode === ""
                          // }
                          // helperText={
                          //   (orderForm?.shipping_address?.province === "" ||
                          //     orderForm?.shipping_address?.district === "" ||
                          //     orderForm?.shipping_address?.subdistrict === "" ||
                          //     orderForm?.shipping_address?.zipcode === "") &&
                          //   "Please select address"
                          // }
                        />
                      )}
                    />
                  </Grid>
                  <Grid xs={12} sm={10} md={5.8} my={{ xs: 1, sm: 1, md: 0 }}>
                    <TextField
                      label="บ้านเลขที่/หมู่บ้าน/ตึก/ซอย"
                      variant="outlined"
                      fullWidth
                      required
                      value={orderForm?.shipping_address?.address ?? ""}
                      onChange={({ target }) => {
                        setOrderForm((form) => ({
                          ...form,
                          shipping_address: {
                            ...form.shipping_address,
                            address: target.value,
                          },
                        }));
                      }}
                      // error={!!errors[`contact.address`]}
                      // helperText={
                      //   !!errors[`contact.address`]
                      //     ? "Please enter address"
                      //     : ""
                      // }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} mb={2}>
                <Row margin="0 0 16px 0">
                  <Topic>เลขที่ Sale Quotation</Topic>
                </Row>

                <Grid
                  container
                  justifyContent={{ sm: "center", md: "flex-start" }}
                >
                  <Grid xs={12} sm={10} md={5.8} my={{ sm: 1, md: 0 }}>
                    <Autocomplete
                      aria-required={true}
                      id="quotation-select"
                      isOptionEqualToValue={(option, value) => {
                        return option._id === value._id;
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          key={`quotation-${option.running_number}`}
                        >
                          {option.running_number}
                        </li>
                      )}
                      options={quotationsList}
                      value={orderForm?.ref_quotation || null}
                      onChange={(e, value) => {
                        setOrderForm((form) => ({
                          ...form,
                          ref_quotation: value,
                        }));
                      }}
                      getOptionLabel={(option) =>
                        option.running_number || option
                      }
                      filterOptions={filterOptions}
                      sx={{
                        width: "100%",
                        background: "#fff",
                        ".MuiOutlinedInput-root": {
                          paddingLeft: "16px",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="TextField-without-border-radius"
                          {...params}
                          label="Sale Quotation No."
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} mb={4}>
                <Row margin="0 0 16px 0">
                  <Topic>ใบเสนอราคา (My Account)</Topic>
                </Row>

                <Grid
                  container
                  justifyContent={{ sm: "center", md: "flex-start" }}
                >
                  <Grid xs={12} sm={10} md={5.8} my={{ sm: 1, md: 0 }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <>
                            {checkNotEmpty(orderForm?.quotation_pdf) ? (
                              <IconButton
                                // sx={{ padding: 0 }}
                                onClick={() => {
                                  setOrderForm({
                                    ...orderForm,
                                    quotation_pdf: "",
                                  });
                                }}
                              >
                                <DeleteOutlineIcon
                                  sx={{ color: Primary, cursor: "pointer" }}
                                />
                              </IconButton>
                            ) : (
                              <UploadPdf
                                callBackFile={(fileCallBlack) => {
                                  setOrderForm({
                                    ...orderForm,
                                    quotation_pdf: fileCallBlack,
                                  });
                                }}
                                closeAlert={false}
                              >
                                <IconButton>
                                  <AttachFileIcon
                                    sx={{
                                      color: Black,
                                      cursor: "pointer",
                                      fontSize: font.size.lg,
                                      ":hover": { color: "#e04132" },
                                    }}
                                  />
                                </IconButton>
                              </UploadPdf>
                            )}
                          </>
                        ),
                      }}
                      placeholder="อัพโหลดไฟล์ .pdf ขนาดไม่เกิน 10 MB"
                      InputLabelProps={{ shrink: true }}
                      value={
                        typeof orderForm?.quotation_pdf !== "object"
                          ? orderForm?.quotation_pdf
                          : orderForm?.quotation_pdf?.originalFileName ||
                            orderForm?.quotation_pdf?.name ||
                            ""
                      }
                      // error={!checkNotEmpty(orderForm?.quotation_pdf)}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} mb={1}>
                <Row margin="0 0 16px 0">
                  <Topic>
                    วันหมดอายุของออเดอร์<Topic required>*</Topic>
                  </Topic>
                </Row>

                <Grid
                  container
                  mb={1}
                  justifyContent={{ sm: "center", md: "flex-start" }}
                >
                  <Grid xs={12} sm={10} md={5.8} my={{ sm: 1, md: 0 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="วันหมดอายุ*"
                        inputFormat="DD/MM/YYYY"
                        value={orderForm?.expire_date || null}
                        onChange={(newValue) => {
                          setOrderForm((form) => ({
                            ...form,
                            expire_date: dayjs(newValue).format("YYYY-MM-DD"),
                          }));
                        }}
                        required
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              width: "100%",
                              background: "#fff",
                              ".MuiOutlinedInput-root": {
                                paddingRight: "18px",
                              },
                            }}
                            // error={!!formErrors[`document_date`]}
                            // helperText={
                            //   !!formErrors[`document_date`]
                            //     ? "Please select document date"
                            //     : ""
                            // }
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12}>
                <Row margin="0 0 16px 0">
                  <Topic>
                    รหัสเซลล์<Topic required>*</Topic>
                  </Topic>
                </Row>

                <Grid
                  container
                  justifyContent={{ sm: "center", md: "flex-start" }}
                >
                  <Grid xs={12} sm={10} md={5.8} my={{ sm: 1, md: 0 }}>
                    <Autocomplete
                      disablePortal
                      id="admin-select"
                      options={adminList}
                      getOptionLabel={(option) =>
                        `${option?.first_name} ${option?.last_name}`
                      }
                      value={selectedSale}
                      onChange={(event, newValue) => {
                        setSelectedSale(newValue);
                        setOrderForm((prev) => ({
                          ...prev,
                          created_by: {
                            ...prev.created_by,
                            user_id: newValue?._id,
                          },
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="เลือกเซลล์"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
        </Panel>

        <LineSection large />

        <Product>
          <Grid
            container
            xs={12}
            // mb={selectedProduct.length === 0 ? { sm: 10 } : { md: 0 }}
          >
            <Grid item xs={9} mb={3}>
              <Topic>
                เพิ่มสินค้า<Topic required>*</Topic>
              </Topic>
            </Grid>

            <Grid item xs={3} mb={3}>
              <Button
                variant="contained"
                className="Button-Add"
                sx={{
                  width: "100%",
                  maxWidth: 350,
                  fontSize: font.size.sm,
                }}
                startIcon={<AddIcon />}
                onClick={() => openModal(`product.add-product-bottom-sheet`)}
              >
                เพิ่มสินค้าใหม่
              </Button>
            </Grid>

            <Autocomplete
              aria-required={true}
              multiple
              id="combo-box-similars"
              getOptionSelected={(option, value) => option._id === value._id}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              renderOption={(props, option, { selected }) => (
                <li {...props} key={`item-${option._id}`}>
                  {!!option?.group_image?.product_display_image === false ? (
                    <ImageEmpty>
                      <InsertPhotoIcon
                        sx={{
                          color: "rgba(0, 0, 0, 0.54)",
                          cursor: "pointer",
                        }}
                      />
                    </ImageEmpty>
                  ) : (
                    <img
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "16px",
                        marginRight: "8px",
                      }}
                      src={
                        option?.group_image?.product_display_image
                          ? option?.group_image?.product_display_image.replace(
                              ".com",
                              ".com/300x300",
                            )
                          : ""
                      }
                      alt={option?.group_image?.product_display_image}
                    />
                  )}
                  <ProductChoiceDetail>
                    {/* name */}
                    <SpanProductDetail nameProd>
                      {option?.product?.item_name
                        ? option?.product?.item_name
                        : "ไม่มีชื่อ"}
                    </SpanProductDetail>

                    {/* size */}
                    <SpanProductDetail center>
                      {option?.size?.quantity === "size"
                        ? `${option?.size?.width} ${
                            getLocale() === "th"
                              ? option?.size?.unit_width?.unit_th
                              : option?.size?.unit_width?.unit_en
                          } x ${option?.size?.height} ${
                            getLocale() === "th"
                              ? option?.size?.unit_height?.unit_th
                              : option?.size?.unit_height?.unit_en
                          } x ${option?.size?.thickness} ${
                            getLocale() === "th"
                              ? option?.size?.unit_thickness?.unit_th
                              : option?.size?.unit_thickness?.unit_en
                          }`
                        : option?.size?.quantity === "capacity"
                          ? `${option?.size?.capacity_size} ${
                              getLocale() === "th"
                                ? option?.size?.unit_capacity?.unit_th
                                : option?.size?.unit_capacity?.unit_en
                            }`
                          : getLocale() === "th"
                            ? "สินค้าสั่งทำพิเศษ"
                            : "Made by order"}
                    </SpanProductDetail>

                    {/* item_code */}
                    <SpanProductDetail>
                      {option?.product?.item_code
                        ? option?.product?.item_code
                        : "-"}
                    </SpanProductDetail>

                    {/* choice name */}
                    <SpanProductDetail center>
                      {option?.name !== "" ? `( ${option?.name} )` : `-`}
                    </SpanProductDetail>

                    {/* price */}
                    <SpanProductDetail price>
                      {convertPrice(
                        option?.group_price?.is_start_price === true
                          ? option?.group_price?.start_price
                          : option?.group_price.special_price > 0 &&
                              option?.group_price.special_price !== null &&
                              option?.group_price.special_price !== undefined
                            ? option?.group_price.special_price
                            : option?.group_price?.price,
                      )}
                    </SpanProductDetail>
                  </ProductChoiceDetail>
                </li>
              )}
              options={productList}
              limitTags={2}
              value={selectedProduct}
              onChange={(event, newValue, reason) => {
                if (selectedProduct.length > 0 && newValue.length === 0) {
                  openDialog({
                    type: "confirm",
                    title: "คุณต้องการลบสินค้าทั้งหมดใช่หรือไม่?",
                    onConfirm: () => {
                      setSelectedProduct([]);
                      setOrderForm((form) => ({
                        ...form,
                        seller_list_orders: [],
                        total_seller_price: 0,
                      }));
                      closeDialog();
                    },
                    maxWidth: 342,
                  });
                } else {
                  handleSelectProduct([...newValue], reason);
                  setSelectedProduct([...newValue]);
                }
                handleSumPrice();
              }}
              getOptionLabel={(option) => {
                return (
                  option?.product?.item_code +
                  " - " +
                  option?.product?.item_name +
                  (option.name !== "" ? ` - (` + option.name + `)` : ``)
                );
              }}
              filterOptions={createFilterOptions({
                matchFrom: "any",
                limit: 100,
              })}
              sx={{
                width: "100%",
                background: "#fff",
                borderRadius: "16px",
              }}
              renderInput={(params) => (
                <TextField
                  className="TextField-without-border-radius"
                  {...params}
                  required
                  label="เลือกสินค้า"
                  // error={!!errors[`product_choice_moods`]}
                  // helperText={
                  //   !!errors[`product_choice_moods`]
                  //     ? "กรุณาเลือกสินค้า"
                  //     : "เลือกได้ไม่เกิน 5 สินค้า"
                  // }
                />
              )}
            />
            {/* } */}
          </Grid>
          {!!orderForm?.seller_list_orders &&
            orderForm?.seller_list_orders.length > 0 &&
            orderForm?.seller_list_orders.map((seller, index_seller) => {
              const _seller =
                seller?.product_choice_orders[0]?.product_choice_order?.product
                  ?.user?.seller;
              const isCreditCardPayable =
                _seller?.is_sell && _seller?.pay_type === "full";

              return (
                <Grid
                  container
                  xs={12}
                  my={3}
                  // pb={deviceWidth <= 835 ? 10 : 0}
                  key={seller._id}
                >
                  <PanelProduct>
                    <HeaderPanel>
                      <ShopName>
                        {seller?.seller_name ??
                          seller?.product_choice_orders[0]?.product_choice_order
                            ?.product?.user?.seller?.company_name}
                      </ShopName>
                    </HeaderPanel>

                    <BodyPanel>
                      {seller?.product_choice_orders.map(
                        (product, index_choice) => (
                          <div key={`${product._id} - ${index_choice}`}>
                            <Grid container justifyContent="space-between">
                              <Grid item xs={4}>
                                <TextHeight>
                                  {product?.product?.item_name ??
                                    product?.product_choice_order?.product
                                      ?.item_name}
                                </TextHeight>
                              </Grid>

                              <Grid
                                item
                                xs={2}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  cursor: "pointer",
                                }}
                              >
                                <IconButton
                                  // aria-label="delete"
                                  sx={{
                                    padding: 0,
                                  }}
                                  onClick={() => {
                                    removeProductSelect(
                                      index_seller,
                                      index_choice,
                                      product.product_choice_order._id,
                                    );
                                  }}
                                >
                                  <DeleteOutlineIcon
                                    sx={{ color: "var(--primary-color)" }}
                                  />
                                </IconButton>
                              </Grid>
                            </Grid>

                            <Grid
                              container
                              justifyContent="space-between"
                              py={1}
                            >
                              <Grid item xs={12}>
                                <ProductDetail>
                                  {product?.product?.item_code ??
                                    product?.product_choice_order?.product
                                      ?.item_code}
                                </ProductDetail>
                              </Grid>
                            </Grid>

                            {product?.color && (
                              <Grid
                                container
                                justifyContent="space-between"
                                py={{ sm: 0, md: 1 }}
                              >
                                <Grid item xs={12}>
                                  <ProductDetail>{`${product?.color?.color_th} / ${product?.texture_type?.type_th}`}</ProductDetail>
                                </Grid>
                              </Grid>
                            )}
                            <Grid
                              container
                              py={1}
                              justifyContent={{ xs: "space-between" }}
                            >
                              {product?.size?.width && (
                                <Grid
                                  container
                                  xs={12}
                                  sm={12}
                                  md={5}
                                  alignItems="center"
                                  pb={{ xs: 2, md: 0 }}
                                >
                                  {/* <ProductDetail>{`ขนาด : ${product?.size?.width} ${product?.size?.unit_width?.unit_th} x ${product?.size?.height} ${product?.size?.unit_height?.unit_th} x ${product?.size?.thickness} ${product?.size?.unit_thickness?.unit_th}`}</ProductDetail> */}

                                  <ProductDetail>{`ขนาด : ${
                                    product?.size?.quantity === "size"
                                      ? `${product?.size?.width} ${
                                          getLocale() === "th"
                                            ? product?.size?.unit_width?.unit_th
                                            : product?.size?.unit_width?.unit_en
                                        } x ${product?.size?.height} ${
                                          getLocale() === "th"
                                            ? product?.size?.unit_height
                                                ?.unit_th
                                            : product?.size?.unit_height
                                                ?.unit_en
                                        } x ${product?.size?.thickness} ${
                                          getLocale() === "th"
                                            ? product?.size?.unit_thickness
                                                ?.unit_th
                                            : product?.size?.unit_thickness
                                                ?.unit_en
                                        }`
                                      : product?.size?.quantity === "capacity"
                                        ? `${product?.size?.capacity_size} ${
                                            getLocale() === "th"
                                              ? product?.size?.unit_capacity
                                                  ?.unit_th
                                              : product?.size?.unit_capacity
                                                  ?.unit_en
                                          }`
                                        : getLocale() === "th"
                                          ? "สินค้าสั่งทำพิเศษ"
                                          : "Made by order"
                                  }`}</ProductDetail>
                                </Grid>
                              )}

                              <Grid
                                container
                                xs={6.5}
                                sm={5.5}
                                md={3}
                                alignItems="center"
                              >
                                <ButtonQuantity
                                  onClick={() => {
                                    minusVolume(index_seller, index_choice);
                                    handleSumPrice();
                                  }}
                                >
                                  <RemoveRoundedIcon color="error" />
                                </ButtonQuantity>

                                <InputQuantity
                                  type="number"
                                  value={
                                    product?.volume <= 0 ? "" : product?.volume
                                  }
                                  onChange={({ target }) => {
                                    handleVolume(
                                      target.value,
                                      index_seller,
                                      index_choice,
                                    );
                                    handleSumPrice();
                                  }}
                                  onBlur={({ target }) => {
                                    target.value === 0 || target.value === ""
                                      ? handleVolume(
                                          1,
                                          index_seller,
                                          index_choice,
                                        )
                                      : handleVolume(
                                          target.value,
                                          index_seller,
                                          index_choice,
                                        );
                                    handleSumPrice();
                                  }}
                                />

                                <ButtonQuantity
                                  onClick={() => {
                                    addVolume(index_seller, index_choice);
                                    handleSumPrice();
                                  }}
                                >
                                  <AddRoundedIcon color="error" />
                                </ButtonQuantity>
                              </Grid>

                              <Grid
                                container
                                item
                                xs={4.5}
                                sm={5.5}
                                md={4}
                                alignItems="center"
                                justifyContent="flex-end"
                              >
                                <ButtonSumPriceProduct>{`฿${convertIntToCurrency(
                                  product?.volume *
                                    (product?.group_price?.special_price ??
                                      product?.price),
                                )}`}</ButtonSumPriceProduct>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <FormControlLabel
                                label="ช่างติดตั้ง"
                                sx={{
                                  margin: 0,
                                  ".MuiFormControlLabel-label": {
                                    fontSize: "0.875rem",
                                    color: "#252525",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    name="install-price-checkbox"
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#e04132",
                                      },
                                      ".MuiSvgIcon-root": {
                                        fontSize: "1.5rem",
                                      },
                                      padding: "4px 4px 4px 0",
                                    }}
                                    checked={
                                      product.install_detail_group.is_service
                                    }
                                    onChange={({ target }) => {
                                      let formNew = orderForm;
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].install_detail_group.is_service =
                                        target.checked;
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].install_detail_group.total_install =
                                        target.checked ? "" : "";
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].install_detail_group.install_area =
                                        target.checked ? "" : "";
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].install_detail_group.service_price =
                                        target.checked ? "" : "";
                                      setOrderForm((form) => ({
                                        ...form,
                                        ...formNew,
                                      }));
                                      handleSumPrice();
                                    }}
                                  />
                                }
                              />
                            </Grid>

                            {product?.install_detail_group?.is_service && (
                              <>
                                <Grid container>
                                  <FormControlLabel
                                    label="ติดตั้งฟรี"
                                    sx={{
                                      margin: 0,
                                      ".MuiFormControlLabel-label": {
                                        fontSize: "0.875rem",
                                        color: "#252525",
                                      },
                                    }}
                                    control={
                                      <Checkbox
                                        name="install-price-checkbox"
                                        sx={{
                                          "&.Mui-checked": {
                                            color: "#e04132",
                                          },
                                          ".MuiSvgIcon-root": {
                                            fontSize: "1.5rem",
                                          },
                                          padding: "4px 4px 4px 0",
                                        }}
                                        checked={
                                          product.install_detail_group
                                            .free_install ?? false
                                        }
                                        onChange={({ target }) => {
                                          let formNew = orderForm;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].install_detail_group.free_install =
                                            target.checked;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].install_detail_group.total_install =
                                            target.checked ? "" : "";
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].install_detail_group.install_area =
                                            target.checked ? "" : "";
                                          setOrderForm((form) => ({
                                            ...form,
                                            ...formNew,
                                          }));
                                          handleSumPrice();
                                        }}
                                      />
                                    }
                                  />
                                </Grid>

                                <Grid container gap={2}>
                                  <Grid item xs={5.5} sm={4} my={1}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      label="ราคาช่าง/บาท"
                                      value={
                                        product?.install_detail_group
                                          ?.total_install
                                          ? product?.install_detail_group
                                              ?.total_install
                                          : product.install_detail_group
                                                .free_install
                                            ? "ฟรี"
                                            : ""
                                      }
                                      onChange={({ target }) => {
                                        if (target.value * 0 === 0) {
                                          let formNew = orderForm;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].install_detail_group.total_install =
                                            target.value;
                                          setOrderForm((form) => ({
                                            ...form,
                                            ...formNew,
                                          }));
                                          handleSumPrice();
                                        }
                                      }}
                                      sx={{
                                        ".MuiInputBase-inputSizeSmall": {
                                          fontSize: "0.875rem",
                                        },
                                        ".MuiInputLabel-root": {
                                          fontSize: "0.75rem",
                                        },
                                        borderRadius: "16px",
                                      }}
                                      disabled={
                                        product.install_detail_group
                                          .free_install
                                      }
                                    />
                                  </Grid>

                                  <Grid item xs={5.5} sm={4} my={1}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={
                                        product?.install_detail_group
                                          ?.install_area ?? ""
                                      }
                                      label="จำนวนพื้นที่(ตร.ม.)"
                                      onChange={({ target }) => {
                                        if (target.value * 0 === 0) {
                                          let formNew = orderForm;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].install_detail_group.install_area =
                                            target.value;
                                          setOrderForm((form) => ({
                                            ...form,
                                            ...formNew,
                                          }));
                                          handleSumPrice();
                                        }
                                      }}
                                      sx={{
                                        ".MuiInputBase-inputSizeSmall": {
                                          fontSize: "0.875rem",
                                        },
                                        ".MuiInputLabel-root": {
                                          fontSize: "0.75rem",
                                        },
                                        borderRadius: "16px",
                                      }}
                                    />
                                  </Grid>
                                </Grid>

                                <Grid container gap={2}>
                                  <Grid item xs={5.5} sm={4} my={1}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      label="ค่าบริการเพิ่มเติม"
                                      value={
                                        product?.install_detail_group
                                          ?.service_price ?? 0
                                      }
                                      onChange={({ target }) => {
                                        if (target.value * 0 === 0) {
                                          let formNew = orderForm;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].install_detail_group.service_price =
                                            target.value;
                                          setOrderForm((form) => ({
                                            ...form,
                                            ...formNew,
                                          }));
                                          handleSumPrice();
                                        }
                                      }}
                                      sx={{
                                        ".MuiInputBase-inputSizeSmall": {
                                          fontSize: "0.875rem",
                                        },
                                        ".MuiInputLabel-root": {
                                          fontSize: "0.75rem",
                                        },
                                        borderRadius: "16px",
                                      }}
                                    />
                                  </Grid>

                                  <Grid item xs={5.5} sm={4} my={1}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      value={
                                        product?.install_detail_group
                                          ?.service_note ?? ""
                                      }
                                      label="ระบุการบริการ"
                                      onChange={({ target }) => {
                                        // if (target.value * 0 === 0) {
                                        let formNew = orderForm;
                                        formNew.seller_list_orders[
                                          index_seller
                                        ].product_choice_orders[
                                          index_choice
                                        ].install_detail_group.service_note =
                                          target.value;
                                        setOrderForm((form) => ({
                                          ...form,
                                          ...formNew,
                                        }));
                                        // handleSumPrice()
                                        // }
                                      }}
                                      sx={{
                                        ".MuiInputBase-inputSizeSmall": {
                                          fontSize: "0.875rem",
                                        },
                                        ".MuiInputLabel-root": {
                                          fontSize: "0.75rem",
                                        },
                                        borderRadius: "16px",
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </>
                            )}

                            <Grid container>
                              <FormControlLabel
                                label="ส่วนลด"
                                sx={{
                                  margin: 0,
                                  ".MuiFormControlLabel-label": {
                                    fontSize: "0.875rem",
                                    color: "#252525",
                                  },
                                }}
                                control={
                                  <Checkbox
                                    name="install-price-checkbox"
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#e04132",
                                      },
                                      ".MuiSvgIcon-root": {
                                        fontSize: "1.5rem",
                                      },
                                      padding: "4px 4px 4px 0",
                                    }}
                                    checked={
                                      product.is_discount
                                        ? product.is_discount
                                        : product.discount && orderId
                                    }
                                    onChange={({ target }) => {
                                      let formNew = orderForm;
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].is_discount = target.checked;

                                      if (target.checked) {
                                        // ตั้งค่า default discount_type เป็น "amount" เมื่อเลือก checkbox ครั้งแรก
                                        if (
                                          !formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[index_choice]
                                            .discount_type
                                        ) {
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].discount_type = "amount";
                                        }
                                      } else {
                                        // เคลียร์ค่า discount และ discount_percent เมื่อ unchecked
                                        formNew.seller_list_orders[
                                          index_seller
                                        ].product_choice_orders[
                                          index_choice
                                        ].discount = "";
                                        formNew.seller_list_orders[
                                          index_seller
                                        ].product_choice_orders[
                                          index_choice
                                        ].discount_percent = "";
                                        formNew.seller_list_orders[
                                          index_seller
                                        ].product_choice_orders[
                                          index_choice
                                        ].discount_type = "";
                                      }

                                      setOrderForm((form) => ({
                                        ...form,
                                        ...formNew,
                                      }));
                                      handleSumPrice();
                                    }}
                                  />
                                }
                              />
                            </Grid>

                            {/* || (product.discount && orderId)  */}
                            {(product?.discount > 0 ||
                              (product.discount && orderId) ||
                              product.is_discount) && (
                              <Grid container mt={0}>
                                <Grid item xs={12} mb={1}>
                                  <RadioGroup
                                    row
                                    value={product?.discount_type || "amount"}
                                    onChange={({ target }) => {
                                      let formNew = orderForm;
                                      const newDiscountType = target.value;

                                      // Reset discount values when changing type
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].discount_type = newDiscountType;
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].discount = 0;
                                      formNew.seller_list_orders[
                                        index_seller
                                      ].product_choice_orders[
                                        index_choice
                                      ].discount_percent = 0;

                                      setOrderForm((form) => ({
                                        ...form,
                                        ...formNew,
                                      }));
                                      handleSumPrice();
                                    }}
                                    fullWidth
                                  >
                                    <Grid container xs={12}>
                                      <Grid item xs={6} sm={5} md={4} lg={3}>
                                        <FormControlLabel
                                          value="amount"
                                          control={
                                            <Radio
                                              sx={{
                                                color: "#e04132",
                                                "&.Mui-checked": {
                                                  color: "#e04132",
                                                },
                                                "& .MuiSvgIcon-root": {
                                                  fontSize: 20,
                                                },
                                              }}
                                            />
                                          }
                                          label="จำนวนเงิน (บาท)"
                                          sx={{
                                            ".MuiFormControlLabel-label": {
                                              fontSize: "0.875rem",
                                            },
                                          }}
                                        />
                                      </Grid>

                                      <Grid item xs={6} sm={5} md={4} lg={3}>
                                        <FormControlLabel
                                          value="percent"
                                          control={
                                            <Radio
                                              sx={{
                                                color: "#e04132",
                                                "&.Mui-checked": {
                                                  color: "#e04132",
                                                },
                                                "& .MuiSvgIcon-root": {
                                                  fontSize: 20,
                                                },
                                              }}
                                            />
                                          }
                                          label="เปอร์เซ็นต์ (%)"
                                          sx={{
                                            ".MuiFormControlLabel-label": {
                                              fontSize: "0.875rem",
                                            },
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </RadioGroup>
                                </Grid>

                                <Grid item xs={6} sm={5} md={4} lg={3}>
                                  <Grid item xs={11.5}>
                                    {/* <Grid item xs={7} md={2} my={1}> */}
                                    <TextField
                                      required
                                      fullWidth
                                      size="small"
                                      label="จำนวนส่วนลด/บาท"
                                      value={product?.discount ?? 0}
                                      disabled={
                                        product?.discount_type !== "amount"
                                      }
                                      onChange={({ target }) => {
                                        if (target.value * 0 === 0) {
                                          let formNew = orderForm;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].discount = target.value;
                                          setOrderForm((form) => ({
                                            ...form,
                                            ...formNew,
                                          }));
                                        }
                                      }}
                                      onBlur={() => {
                                        handleSumPrice();
                                      }}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            ฿
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        ".MuiInputBase-inputSizeSmall": {
                                          fontSize: "0.875rem",
                                        },
                                        ".MuiInputLabel-root": {
                                          fontSize: "0.75rem",
                                        },
                                        borderRadius: "16px",
                                      }}
                                    />
                                  </Grid>
                                </Grid>

                                <Grid item xs={6} sm={5} md={4} lg={3}>
                                  <Grid item xs={11.5}>
                                    {/* <Grid item xs={7} md={2} my={1}> */}
                                    <TextField
                                      required
                                      fullWidth
                                      size="small"
                                      label="จำนวนส่วนลด/เปอร์เซ็นต์"
                                      value={product?.discount_percent ?? 0}
                                      disabled={
                                        product?.discount_type !== "percent"
                                      }
                                      onChange={({ target }) => {
                                        if (target.value * 0 === 0) {
                                          let formNew = orderForm;
                                          const percentValue =
                                            parseFloat(target.value) || 0;

                                          // คำนวณส่วนลดจากเปอร์เซ็นต์
                                          const basePrice =
                                            (product?.group_price
                                              ?.special_price ??
                                              product?.price) ||
                                            0;
                                          const volume = product?.volume || 0;
                                          const totalPrice = basePrice * volume;
                                          const discountAmount =
                                            (totalPrice * percentValue) / 100;

                                          // เก็บค่าเปอร์เซ็นต์และจำนวนเงินส่วนลด
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].discount_percent = percentValue;
                                          formNew.seller_list_orders[
                                            index_seller
                                          ].product_choice_orders[
                                            index_choice
                                          ].discount = discountAmount;

                                          setOrderForm((form) => ({
                                            ...form,
                                            ...formNew,
                                          }));
                                        }
                                      }}
                                      onBlur={() => {
                                        handleSumPrice();
                                      }}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            %
                                          </InputAdornment>
                                        ),
                                      }}
                                      sx={{
                                        ".MuiInputBase-inputSizeSmall": {
                                          fontSize: "0.875rem",
                                        },
                                        ".MuiInputLabel-root": {
                                          fontSize: "0.75rem",
                                        },
                                        borderRadius: "16px",
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}

                            <Grid
                              container
                              pt={2}
                              pb={1}
                              justifyContent="space-between"
                            >
                              <Grid item>
                                <TextMedium>ราคารวม</TextMedium>
                              </Grid>

                              <Grid item>
                                <TextHeight bold>
                                  {convertPrice(product.total)}
                                </TextHeight>
                              </Grid>
                            </Grid>

                            {!!product.description ? (
                              <Grid container>
                                <TextField
                                  fullWidth
                                  multiline
                                  value={product?.description}
                                  sx={{
                                    ".MuiInputBase-input": {
                                      fontSize: "0.875rem",
                                      color: "#6C6C70",
                                    },
                                  }}
                                  onChange={({ target }) => {
                                    let formNew = orderForm;
                                    formNew.seller_list_orders[
                                      index_seller
                                    ].product_choice_orders[
                                      index_choice
                                    ].description = target.value;
                                    setOrderForm((form) => ({
                                      ...form,
                                      ...formNew,
                                    }));
                                  }}
                                />
                              </Grid>
                            ) : (
                              <Grid container px={1}>
                                <Grid item>
                                  <FormControlLabel
                                    label="เพิ่มรายละเอียด"
                                    sx={{
                                      color: "var(--secondary-color)",
                                      fontSize: font.size.sm,
                                      fontWeight: 400,
                                      ".MuiTypography-root": {
                                        fontSize: "0.875rem!important",
                                      },
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          ":hover": {
                                            ".MuiSvgIcon-root": {
                                              color: "var(--primary-color)",
                                            },
                                          },
                                          "&.MuiFormControlLabel-label.Mui-disabled":
                                            {
                                              color: "var(--secondary-color)",
                                            },
                                        }}
                                        icon={
                                          <RadioButtonUncheckedIcon
                                            sx={{
                                              color: "var(--lightgrey-color)",
                                              paddingLeft: 0,
                                            }}
                                          />
                                        }
                                        checkedIcon={
                                          <RadioButtonUncheckedIcon
                                            sx={{
                                              color: "var(--primary-color)",
                                            }}
                                          />
                                        }
                                        checked={
                                          product?.description !== ""
                                            ? true
                                            : false
                                        }
                                        onChange={(e) => {
                                          openModal(
                                            `product_list.${1}.description.add-product-descripition-modal`,
                                          );
                                          setSellerIndex(index_seller);
                                          setChoiceIndex(index_choice);
                                        }}
                                      />
                                    }
                                  />
                                </Grid>
                              </Grid>
                            )}

                            <LineSection />
                          </div>
                        ),
                      )}

                      {isCreditCardPayable && (
                        <Grid my={2} container>
                          <Grid container>
                            <TextHeight bold>
                              ค่าธรรมเนียมบัตรเครดิต
                              (ในกรณีที่ไม่ระบุจะใช้อัตราค่าธรรมเนียม 3%)
                            </TextHeight>
                          </Grid>

                          <Grid container py={1}>
                            <Grid item xs={8} sm={5}>
                              <TextField
                                fullWidth
                                size="small"
                                label="ค่าธรรมเนียมบัตรเครดิต"
                                value={
                                  !isNaN(seller?.credit_card_fee)
                                    ? seller?.credit_card_fee
                                    : ""
                                }
                                required
                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Match float number and prevent user from inputting other characters except zero, number and dot
                                  if (!/^\d*\.?\d*$/.test(value)) return;

                                  let formNew = orderForm;
                                  formNew.seller_list_orders.map(
                                    (seller, index) => {
                                      const _seller =
                                        seller?.product_choice_orders[0]
                                          ?.product_choice_order?.product?.user
                                          ?.seller;
                                      const _isCreditCardPayable =
                                        _seller?.is_sell &&
                                        _seller?.pay_type === "full";

                                      // Set the same credit card fee to every order that can be paid by credit card
                                      if (_isCreditCardPayable) {
                                        seller.credit_card_fee = value;
                                      }
                                      return seller;
                                    },
                                  );
                                  setOrderForm((form) => ({
                                    ...form,
                                    ...formNew,
                                  }));
                                }}
                                onBlur={() => {
                                  handleSumPrice();
                                }}
                                sx={{ borderRadius: "16px" }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      <Grid my={2} container>
                        <Grid container>
                          <TextHeight bold>ค่าจัดส่ง</TextHeight>
                          {/* <TextHeight bold>ค่าจัดส่งรวม VAT</TextHeight> */}
                        </Grid>

                        <Grid container py={1}>
                          <Grid item xs={4} sm={3} md={2}>
                            <TextField
                              fullWidth
                              size="small"
                              label="ค่าจัดส่งสินค้า"
                              value={
                                seller?.delivery_detail_group?.delivery_price ??
                                null
                              }
                              required
                              onChange={({ target }) => {
                                if (target.value * 0 === 0) {
                                  let formNew = orderForm;
                                  formNew.seller_list_orders[
                                    index_seller
                                  ].delivery_detail_group.delivery_price =
                                    target.value;
                                  setOrderForm((form) => ({
                                    ...form,
                                    ...formNew,
                                  }));
                                  handleSumPrice();
                                }
                              }}
                              sx={{ borderRadius: "16px" }}
                            />
                          </Grid>

                          <Grid xs={7} sm={6} md={3} item ml={2}>
                            <Autocomplete
                              aria-required={true}
                              id="delivery-select"
                              isOptionEqualToValue={(option, value) =>
                                option._id === value._id
                              }
                              renderOption={(props, option) => (
                                <li {...props} key={`province-${option._id}`}>
                                  {option.type_th}
                                </li>
                              )}
                              options={selectedDelivery}
                              value={
                                seller?.delivery_detail_group?.delivery_type ??
                                ""
                              }
                              onChange={(e, value) => {
                                let form = orderForm;
                                form.seller_list_orders[
                                  index_seller
                                ].delivery_detail_group.delivery_type = value;
                                setOrderForm((form) => ({
                                  ...form,
                                  ...orderForm,
                                }));
                                handleSumPrice();
                              }}
                              getOptionLabel={(option) =>
                                option.type_th || option
                              }
                              filterOptions={filterOptions}
                              sx={{
                                width: "100%",
                                background: "#fff",
                                height: "40px",
                                ".MuiOutlinedInput-root": {
                                  padding: "0 0 0 8px",
                                  height: "40px",
                                  borderRadius: "16px",
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  className="TextField-without-border-radius"
                                  {...params}
                                  placeholder="ช่องทางการจัดส่ง"
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid my={2} container>
                        <Grid container>
                          <TextHeight bold>ค่าแพ็คสินค้า</TextHeight>
                        </Grid>

                        <Grid container py={1}>
                          <Grid item xs={8} sm={5}>
                            <TextField
                              fullWidth
                              size="small"
                              label="ค่าแพ็คสินค้า"
                              value={seller?.packaging_fee ?? null}
                              required
                              onChange={({ target }) => {
                                if (target.value * 0 === 0) {
                                  let formNew = orderForm;
                                  formNew.seller_list_orders[
                                    index_seller
                                  ].packaging_fee = target.value;
                                  setOrderForm((form) => ({
                                    ...form,
                                    ...formNew,
                                  }));
                                  handleSumPrice();
                                }
                              }}
                              sx={{ borderRadius: "16px" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid my={2}>
                        <Grid container>
                          <TextHeight bold>วิธีการชำระเงิน</TextHeight>
                        </Grid>

                        <Grid container xs={7}>
                          <RadioGroup
                            row
                            defaultValue="paid"
                            name="payment-type"
                            value={seller?.status_payment?.status ?? "paid"}
                            onChange={({ target }) => {
                              let formNew = orderForm;
                              formNew.seller_list_orders[
                                index_seller
                              ].status_payment.status = target.value;
                              formNew.seller_list_orders[
                                index_seller
                              ].status_payment.deposit_price = "";
                              setOrderForm((form) => ({
                                ...form,
                                ...formNew,
                              }));
                              handleSumPrice();
                            }}
                          >
                            <FormControlLabel
                              value="paid"
                              control={
                                <Radio
                                  sx={{
                                    color: "#e04132",
                                    "&.Mui-checked": {
                                      color: "#e04132",
                                    },
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 22,
                                    },
                                  }}
                                />
                              }
                              label="ชำระเต็มจำนวน"
                            />

                            <FormControlLabel
                              value="deposit"
                              control={
                                <Radio
                                  sx={{
                                    color: "#e04132",
                                    "&.Mui-checked": {
                                      color: "#e04132",
                                    },
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 22,
                                    },
                                  }}
                                />
                              }
                              label="ชำระมัดจำ"
                            />
                          </RadioGroup>
                        </Grid>

                        {seller?.status_payment?.status === "deposit" && (
                          <Grid item xs={8} sm={5} mt={1}>
                            <TextField
                              required
                              fullWidth
                              size="small"
                              label="จำนวนเงินมัดจำ"
                              value={seller?.status_payment.deposit_price ?? ""}
                              onChange={({ target }) => {
                                if (target.value * 0 === 0) {
                                  let formNew = orderForm;
                                  formNew.seller_list_orders[
                                    index_seller
                                  ].status_payment.deposit_price = target.value;
                                  setOrderForm((form) => ({
                                    ...form,
                                    ...formNew,
                                  }));
                                  handleSumPrice();
                                }
                              }}
                              sx={{ borderRadius: "16px" }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </BodyPanel>

                    <FooterPanel>
                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>ราคาสินค้า</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          <Price price>
                            {convertPrice(
                              seller?.product_choice_orders
                                .map(
                                  (prod) =>
                                    prod.volume *
                                    (prod.group_price.special_price ??
                                      prod.price),
                                )
                                .reduce((sum, number) => {
                                  return Number(sum) + Number(number);
                                }, 0),
                            )}
                          </Price>
                        </Grid>
                      </Grid>

                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>ค่าติดตั้ง</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          <Price price>
                            {convertPrice(seller?.total_installer)}
                          </Price>
                        </Grid>
                      </Grid>

                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>ส่วนลด</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          <Price price discount>{`-${convertPrice(
                            seller?.total_discount,
                          )}`}</Price>
                        </Grid>
                      </Grid>

                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>ราคารวม</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          <Price price>
                            {convertPrice(seller?.total_price)}
                          </Price>
                        </Grid>
                      </Grid>

                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>{`ภาษีมูลค่าเพิ่ม (7%)`}</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          <Price price>{`+${convertPrice(seller?.vat)}`}</Price>
                        </Grid>
                      </Grid>

                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>{`ค่าจัดส่ง ${
                            seller?.delivery_detail_group?.delivery_type
                              ? `(${seller?.delivery_detail_group?.delivery_type?.type_th}) + ภาษีมูลค่าเพิ่ม (7%)`
                              : `+ ภาษีมูลค่าเพิ่ม (7%)`
                          }`}</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          {!!seller?.delivery_detail_group?.delivery_price &&
                          !!seller?.delivery_detail_group?.is_delivery ? (
                            <Price price>{convertPrice(0)}</Price>
                          ) : (
                            <Price price>
                              {convertPrice(seller?.total_delivery)}
                            </Price>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container xs={12} my={1}>
                        <Grid item xs={6}>
                          <Price>{`ค่าแพ็คสินค้า + ภาษีมูลค่าเพิ่ม (7%)`}</Price>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-end">
                          {!checkNotEmpty(seller?.packaging_fee) ? (
                            <Price price>{convertPrice(0)}</Price>
                          ) : (
                            <Price price>
                              {convertPrice(seller?.total_packaging)}
                            </Price>
                          )}
                        </Grid>
                      </Grid>

                      <LineSection />

                      {seller?.status_payment?.status === "paid" ? (
                        <Grid container xs={12} my={1}>
                          <Grid item xs={6}>
                            <TextHeight bold>{`จำนวนเงินทั้งสิ้น`}</TextHeight>
                          </Grid>

                          <Grid item xs={6} justifyContent="flex-end">
                            <Price sum price>
                              {convertPrice(seller?.total_all)}
                            </Price>
                          </Grid>
                        </Grid>
                      ) : (
                        <>
                          <Grid container xs={12} my={1}>
                            <Grid item xs={6}>
                              <TextHeight bold>{`ยอดมัดจำ`}</TextHeight>
                            </Grid>

                            <Grid item xs={6} justifyContent="flex-end">
                              <Price sum price>
                                {convertPrice(
                                  seller?.status_payment?.deposit_price,
                                )}
                              </Price>
                            </Grid>
                          </Grid>

                          <Grid container xs={12} my={1}>
                            <Grid item xs={6}>
                              <Price>{`ยอดค้างชำระ`}</Price>
                            </Grid>

                            <Grid item xs={6} justifyContent="flex-end">
                              <Price sum price>
                                {convertPrice(seller?.outstanding_balance)}
                              </Price>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </FooterPanel>
                  </PanelProduct>

                  {!!seller.note ? (
                    <Grid container>
                      <TextField
                        fullWidth
                        multiline
                        value={seller?.note}
                        sx={{
                          ".MuiInputBase-input": {
                            fontSize: "0.875rem",
                            color: "#6C6C70",
                          },
                        }}
                        onChange={({ target }) => {
                          let formNew = orderForm;
                          formNew.seller_list_orders[index_seller].note =
                            target.value;
                          setOrderForm((form) => ({ ...form, ...formNew }));
                        }}
                      />
                    </Grid>
                  ) : (
                    <Grid container>
                      <AddRemark
                        onClick={() => {
                          openModal(`remark.add-remark-modal`);
                          setSellerIndex(index_seller);
                        }}
                      >
                        <AddRoundedIcon />
                        เพิ่มหมายเหตุ
                      </AddRemark>
                    </Grid>
                  )}
                </Grid>
              );
            })}

          {deviceWidth <= 835 ? (
            <ButtomSheet>
              {!!orderForm?.seller_list_orders &&
                orderForm?.seller_list_orders.length > 0 && (
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <TotalPrice>ยอดรวม</TotalPrice>
                    </Grid>

                    <Grid>
                      <TotalPrice price>
                        {convertPrice(orderForm?.total_seller_price)}
                      </TotalPrice>
                    </Grid>
                  </Grid>
                )}

              {!!orderId ? (
                <Grid container xs={12} mt={3} justifyContent="center">
                  <ButtonSubmit onClick={() => handleUpdateOrder()}>
                    แก้ไข
                  </ButtonSubmit>
                </Grid>
              ) : (
                <Grid container xs={12} mt={3} justifyContent="center">
                  <ButtonSubmit
                    onClick={() => handleCreateOrder()}
                    disabled={isDisableSubmit()}
                  >
                    สร้าง
                  </ButtonSubmit>
                </Grid>
              )}
            </ButtomSheet>
          ) : (
            <>
              {!!orderForm?.seller_list_orders &&
                orderForm?.seller_list_orders.length > 0 && (
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <TotalPrice>ยอดรวม</TotalPrice>
                    </Grid>

                    <Grid>
                      <TotalPrice price>
                        {convertPrice(orderForm?.total_seller_price)}
                      </TotalPrice>
                    </Grid>
                  </Grid>
                )}

              {!!orderId ? (
                <Grid container xs={12} mt={5} justifyContent="center">
                  <ButtonSubmit onClick={() => handleUpdateOrder()}>
                    แก้ไข
                  </ButtonSubmit>
                </Grid>
              ) : (
                <Grid container xs={12} mt={5} justifyContent="center">
                  <ButtonSubmit
                    onClick={() => handleCreateOrder()}
                    disabled={isDisableSubmit()}
                  >
                    สร้าง
                  </ButtonSubmit>
                </Grid>
              )}
            </>
          )}
        </Product>
        <ModalProduct
          // quoList={formData?.product}
          docType={"other"}
          isOpen={getModalState(`order_list.add-product-bottom-sheet`)?.isOpen}
          onClose={
            () => close(`order_list.add-product-bottom-sheet`)
            // setSheetType("");
          }
          // onAppendData={onAppendData}
          // onAppendData={handleOnAppendData}
          // onRemoveElement={onRemoveElement}
          // onRemoveElement={
          //   sheetType === "service"
          //     ? onRemoveService
          //     : sheetType === "product"
          //       ? onRemoveProduct
          //       : onRemoveOther
          // }
        />
        <ModalAddition
          type="desc"
          // descData={orderForm?.seller_list_orders[indexSeller]?.product?.description}
          docType="product"
          isOpen={
            getModalState(
              `product_list.${1}.description.add-product-descripition-modal`,
            )?.isOpen
          }
          isEdit={
            getModalState(
              `product_list.${1}.description.add-product-descripition-modal`,
            )?.isEdit
          }
          onClose={() =>
            close(
              `product_list.${1}.description.add-product-descripition-modal`,
            )
          }
          onSubmit={(val) => {
            let formNew = orderForm;
            formNew.seller_list_orders[sellerIndex].product_choice_orders[
              choiceIndex
            ].description = val;
            setOrderForm((form) => ({ ...form, ...formNew }));
            close(
              `product_list.${1}.description.add-product-descripition-modal`,
            );
          }}
        />

        {!!orderForm?.seller_list_orders && (
          <ModalAddition
            type="remark"
            descData={orderForm?.seller_list_orders[sellerIndex]?.note}
            docType="remark"
            isOpen={getModalState(`remark.add-remark-modal`)?.isOpen}
            isEdit={getModalState(`remark.add-remark-modal`)?.isEdit}
            onClose={() => close(`remark.add-remark-modal`)}
            onSubmit={(val) => {
              let formNew = orderForm;
              formNew.seller_list_orders[sellerIndex].note = val;
              setOrderForm((form) => ({ ...form, ...formNew }));
              close(`remark.add-remark-modal`);
            }}
          />
        )}

        <ProductSheet
          isOpen={getModalState(`product.add-product-bottom-sheet`)?.isOpen}
          onClose={() => close(`product.add-product-bottom-sheet`)}
          onAppendData={(a) => {
            // fetchProducts();
            handleSelectProduct([...selectedProduct, a], "addProduct");
            setSelectedProduct([...selectedProduct, a]);

            handleSumPrice();
            close(`product.add-product-bottom-sheet`);
          }}
        />
      </Container>
    </Main>
  );
};

export default OrderDraft;
